import { getHeaderOptions, getHttpService } from './http-service';

const httpClient = getHttpService();

export const sendEmailValidationCode = (workEmail: string) => {
  return httpClient.post(
    `/emailVerification`,
    { workEmail },
    {
      headers: getHeaderOptions(),
    },
  );
};

export const validateEmailCode = (
  workEmail: string,
  verificationCode: string,
) => {
  return httpClient.post(
    `/emailVerification/verifyCode`,
    { workEmail, verificationCode },
    {
      headers: getHeaderOptions(),
    },
  );
};
